import CryptoJS from 'crypto-js';
import { encryptedConfig } from './config.enc.js';


// Decrypt function
const bytes = CryptoJS.AES.decrypt(encryptedConfig, 'GALAXY');
const decryptedConfig = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

export const config = decryptedConfig;
